import httpUtil from "@/utils/httpUtil";

export const selectPrintProduce = params => httpUtil.get("/print/produce", params);

export const addPrintProduce = params => httpUtil.post("/print/produce", params);

export const delPrintProduce = params => httpUtil.post("/print/produce/delete", params);

